
import { defineStore } from "pinia"
import { computed, nextTick, ref, toRefs, watch } from "vue"
import { useDropdownUser } from "@/globals/stores/storeDropdownData"
import { getComputedPageLayout } from "@/helpers/api"

type WksItem = { wks_uuid: string; answer_uuid: string }
type ListItem = { studentUUID: string; shortname: string; wks: WksItem[] }

export const useWksDropdownStore = defineStore("WksDropdownStore", () => {

  const _list = ref<ListItem[]>([])
  const selectedIndex = ref(0)

  const selectStudentUuid = ref<string>("")

  const isClass = ref(false)


  const isPeer = ref(false)
  const peerLabel = ref("Peer")

  const { getKind, getItem } = toRefs(useDropdownUser())

  const list = computed<ListItem[]>({
    get: () => {
      const layout = getComputedPageLayout<{ labels: { item0: string } }>("1640")

      if (isClass.value) {
        return [{ shortname: layout.value?.labels.item0 ?? "Class", studentUUID: "", wks: [] }, ..._list.value]
      } else if (isPeer.value) {
        return [{ shortname: peerLabel.value, studentUUID: "", wks: [] }]
      } else {
        return _list.value.length > 0
          ? _list.value
          : [{ shortname: getItem.value.shortname, studentUUID: (getItem.value as any).uuid ?? "", wks: [] }]
      }
    },
    set: (v) => { _list.value = v },
  })


  watch(
    getKind,
    async (kind) => {
      if (kind === "classroom") {
        isClass.value = true
        await nextTick()
        // selectedIndex.value = list.value.length > 1 ? 1 : 0
        selectedIndex.value = 0
        selectStudentUuid.value = ""
      } else {
        isClass.value = false
        selectedIndex.value = 0
        selectStudentUuid.value = ""
      }
    },
    { immediate: true }
  )

  const inLive = ref(false)
  const listLive = ref<ListItem[]>([])
  const selectedIndexLive = ref(0)


  const viewList = computed<ListItem[]>(() => (inLive.value ? listLive.value : listLive.value))
  const viewSelectedIndex = computed({
    get: () => (inLive.value ? selectedIndexLive.value : selectedIndex.value),
    set: (val: number) => {
      if (inLive.value) selectedIndexLive.value = val
      else selectedIndex.value = val
    },
  })


  function beginLive(target: ListItem) {
    const normal = list.value
    const first = normal[0] ?? null

    const dedupe = new Set<string>()
    const live: ListItem[] = []

    if (first) {
      const key = first.studentUUID ?? "__empty__"
      if (!dedupe.has(key)) {
        dedupe.add(key)
        live.push(first)
      }
    }


    const key = target.studentUUID ?? ""
    if (!dedupe.has(key)) {
      dedupe.add(key)
      live.push(target)
    }


    listLive.value = live
    selectedIndex.value = 1
    console.log("selectedIndex startLive", selectedIndex.value)
    selectStudentUuid.value = key
    inLive.value = true
  }
  function endLive() {

    inLive.value = false
    listLive.value = []
    selectedIndexLive.value = 0
    selectStudentUuid.value = ""
  }


  function getAnswerUUID(studentUUID: string): string | undefined {
    if (!studentUUID) return
    for (const user of viewList.value) {
      if (user.studentUUID === studentUUID && user.wks?.length) {
        return user.wks[0].answer_uuid
      }
    }
  }

  function getUserWksUUID(wksUUID: string): string | undefined {
    for (const user of viewList.value) {
      for (const wks of user.wks) {
        if (wks.wks_uuid === wksUUID) return wks.wks_uuid
      }
    }
  }

  function getUserWorksheetUUID(wksUUID: string): string | undefined {
    for (const user of _list.value) {
      for (const wks of user.wks) {
        if (wks.wks_uuid === wksUUID) return user.studentUUID
      }
    }
  }


  return {
    list, _list, selectedIndex, isClass, isPeer, peerLabel,
    inLive, listLive, beginLive, endLive,
    viewList, viewSelectedIndex, selectStudentUuid,
    getAnswerUUID, getUserWksUUID, getUserWorksheetUUID,
  }
})
